import Vue from 'vue'

import Moment from '@finx/web-repository/src/filters/Moment'
import PascalCaseReverse from '@finx/web-repository/src/filters/PascalCaseReverse'

import '@/filters/Currency'
import maskPhone from './mask-phone'
import maskDate from './mask-date-only'

Vue.filter('moment', Moment)
Vue.filter('pascalCaseReverse', PascalCaseReverse)
Vue.filter('maskPhone', maskPhone)
Vue.filter('maskDateOnly', maskDate)
